// extracted by mini-css-extract-plugin
module.exports = {"previewWrapper":"tiiFbsInteraction__previewWrapper___3BvqF","fbsModalContainer":"tiiFbsInteraction__fbsModalContainer___2vPT6","fbsModal":"tiiFbsInteraction__fbsModal___2cqH5"};